<div [hidden]="this.frmGroup.get(this.configData.name)['hidden']" [formGroup]="frmGroup" class = "dhl-component-textarea-v2" [class.disabled]="disabled">
    <div class = "border-textarea">
        <div title="{{configData['toolTip']}}" [ngClass]="[configData.displayErrorMsgClass ? 'dhl-container-textarea-error-v2':'dhl-container-textarea-v2',frmGroup.get(configData.name).value?.length > 0 ? 'filled' : 'empty']">
          <label>  {{configData.label}} <span *ngIf="configData.required">*</span></label>
            <textarea #textarea class="dhl-textarea-v2"
                [ngClass]="{'resize-horizontal': configData.resize === 'horizontal', 'resize-both': configData.resize === 'both', 'resize-vertical': configData.resize === 'vertical',  'resize-none': configData.resize === 'none'}"
                [formControlName]="configData.name" (ngModelChange)="valueChange()"  (focus) = "autoResize(textarea)" (keyup)="autoResize(textarea)" (focusout) = "autoDefaultSize(textarea)"
                maxlength={{maxLen}}
                [required]="configData.required"
                rows = "{{configData.rows}}"
                cols = "1000"></textarea>
        </div>
        <div class="dhl-textarea-static-font-v2 dhl-character-small-size">
            <span class = "left-float" ><label for="configData.description">{{configData.description}}</label></span>
            <span class = "right-float" *ngIf="counter !== 0 && !configData.hideRemainingCharMsg">{{counter}} characters remaining</span>
        </div>
        <div class="dhl-textarea-errMsg-v2"
            *ngIf="((frmGroup.get($safeNavigationMigration(configData?.name))?.touched || frmGroup.get($safeNavigationMigration(configData?.name))?.dirty) && (frmGroup.get(configData.name).errors))">
            <div class="form-field-error"
            [ngClass]="{'hide-error': !(frmGroup.get(configData.name).errors && (frmGroup.get(configData.name).touched ||frmGroup.get(configData.name).value) && !frmGroup.get(configData.name).valid)}">
            <span class="error-icon">
                <img class="dhl-input-error-icon"
                    src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
            </span>

            <span class="error-text" *ngIf="frmGroup.get(configData.name).errors">
                <span class="error-text"
                    *ngIf="frmGroup.get(configData.name)?.errors?.pattern && (validationType === 'NoSpecialCharacter' || validationType === 'NoSpecialCharacterPhone' || validationType === 'DisableAllSpecialCharacters')">
                    {{ enum.special_Character_Validation | translate }}.
                </span>
                <span *ngIf="frmGroup.get(configData.name)?.errors?.pattern && validationType === 'OTMRestrictedSpecialChars'">
                    {{ enum.special_Character_Validation | translate }}.
                </span>
                <span *ngIf="frmGroup.get(configData.name).errors?.groupValidationError">
                    {{$safeNavigationMigration(frmGroup.get(configData.name).errors?.groupValidationError) | translate}}
                </span>
            </span>
        </div>
            <div *ngIf="configData.required === true">*Required </div>
        </div>     
    </div>
</div>
